var map = {
	"./highlight/alpine_climbing_marker.svg": 174,
	"./highlight/circle.svg": 175,
	"./highlight/climbing_marker.svg": 176,
	"./highlight/condition_warning.svg": 177,
	"./highlight/protection_rule.svg": 178,
	"./plain/additional_information_alp.svg": 179,
	"./plain/additional_information_bridge.svg": 180,
	"./plain/additional_information_catering.svg": 181,
	"./plain/additional_information_cave.svg": 182,
	"./plain/additional_information_departure_arrival.svg": 183,
	"./plain/additional_information_lake.svg": 184,
	"./plain/additional_information_marking_point.svg": 185,
	"./plain/additional_information_summit.svg": 186,
	"./plain/additional_information_traverse.svg": 187,
	"./plain/additional_information_waterfall.svg": 188,
	"./plain/alpine_climbing_alp.svg": 189,
	"./plain/alpine_climbing_bridge.svg": 190,
	"./plain/alpine_climbing_catering.svg": 191,
	"./plain/alpine_climbing_cave.svg": 192,
	"./plain/alpine_climbing_climbing_area.svg": 193,
	"./plain/alpine_climbing_departure_arrival.svg": 194,
	"./plain/alpine_climbing_lake.svg": 195,
	"./plain/alpine_climbing_marker.svg": 196,
	"./plain/alpine_climbing_marking_point.svg": 197,
	"./plain/alpine_climbing_summit.svg": 198,
	"./plain/alpine_climbing_traverse.svg": 199,
	"./plain/alpine_climbing_waterfall.svg": 200,
	"./plain/alpine_tour_alp.svg": 201,
	"./plain/alpine_tour_bridge.svg": 202,
	"./plain/alpine_tour_catering.svg": 203,
	"./plain/alpine_tour_cave.svg": 204,
	"./plain/alpine_tour_climbing_area.svg": 205,
	"./plain/alpine_tour_departure_arrival.svg": 206,
	"./plain/alpine_tour_lake.svg": 207,
	"./plain/alpine_tour_marking_point.svg": 208,
	"./plain/alpine_tour_summit.svg": 209,
	"./plain/alpine_tour_traverse.svg": 210,
	"./plain/alpine_tour_waterfall.svg": 211,
	"./plain/archive_alp.svg": 212,
	"./plain/archive_bridge.svg": 213,
	"./plain/archive_catering.svg": 214,
	"./plain/archive_cave.svg": 215,
	"./plain/archive_climbing_area.svg": 216,
	"./plain/archive_departure_arrival.svg": 217,
	"./plain/archive_lake.svg": 218,
	"./plain/archive_marking_point.svg": 219,
	"./plain/archive_summit.svg": 220,
	"./plain/archive_traverse.svg": 221,
	"./plain/archive_waterfall.svg": 222,
	"./plain/climbing_alp.svg": 223,
	"./plain/climbing_bridge.svg": 224,
	"./plain/climbing_catering.svg": 225,
	"./plain/climbing_cave.svg": 226,
	"./plain/climbing_climbing_area.svg": 227,
	"./plain/climbing_climbing_marker.svg": 228,
	"./plain/climbing_departure_arrival.svg": 229,
	"./plain/climbing_lake.svg": 230,
	"./plain/climbing_marker.svg": 231,
	"./plain/climbing_marking_point.svg": 232,
	"./plain/climbing_summit.svg": 233,
	"./plain/climbing_traverse.svg": 234,
	"./plain/climbing_waterfall.svg": 235,
	"./plain/condition_warning.svg": 236,
	"./plain/hut.svg": 135,
	"./plain/mountain_hiking_alp.svg": 237,
	"./plain/mountain_hiking_bridge.svg": 238,
	"./plain/mountain_hiking_catering.svg": 239,
	"./plain/mountain_hiking_cave.svg": 240,
	"./plain/mountain_hiking_climbing_area.svg": 241,
	"./plain/mountain_hiking_departure_arrival.svg": 242,
	"./plain/mountain_hiking_lake.svg": 243,
	"./plain/mountain_hiking_marking_point.svg": 244,
	"./plain/mountain_hiking_summit.svg": 245,
	"./plain/mountain_hiking_traverse.svg": 246,
	"./plain/mountain_hiking_waterfall.svg": 247,
	"./plain/multiple_disciplines_alp.svg": 248,
	"./plain/multiple_disciplines_bridge.svg": 249,
	"./plain/multiple_disciplines_catering.svg": 250,
	"./plain/multiple_disciplines_cave.svg": 251,
	"./plain/multiple_disciplines_climbing_area.svg": 252,
	"./plain/multiple_disciplines_departure_arrival.svg": 253,
	"./plain/multiple_disciplines_lake.svg": 254,
	"./plain/multiple_disciplines_marking_point.svg": 255,
	"./plain/multiple_disciplines_summit.svg": 256,
	"./plain/multiple_disciplines_traverse.svg": 257,
	"./plain/multiple_disciplines_waterfall.svg": 258,
	"./plain/no_disciplines_alp.svg": 134,
	"./plain/no_disciplines_bridge.svg": 133,
	"./plain/no_disciplines_catering.svg": 130,
	"./plain/no_disciplines_cave.svg": 132,
	"./plain/no_disciplines_climbing_area.svg": 128,
	"./plain/no_disciplines_departure_arrival.svg": 127,
	"./plain/no_disciplines_lake.svg": 129,
	"./plain/no_disciplines_marking_point.svg": 126,
	"./plain/no_disciplines_summit.svg": 124,
	"./plain/no_disciplines_traverse.svg": 125,
	"./plain/no_disciplines_waterfall.svg": 131,
	"./plain/protection_area.svg": 259,
	"./plain/protection_rule.svg": 260,
	"./plain/sac_hut.svg": 136,
	"./plain/ski_tour_alp.svg": 261,
	"./plain/ski_tour_bridge.svg": 262,
	"./plain/ski_tour_catering.svg": 263,
	"./plain/ski_tour_cave.svg": 264,
	"./plain/ski_tour_climbing_area.svg": 265,
	"./plain/ski_tour_departure_arrival.svg": 266,
	"./plain/ski_tour_lake.svg": 267,
	"./plain/ski_tour_marking_point.svg": 268,
	"./plain/ski_tour_summit.svg": 269,
	"./plain/ski_tour_traverse.svg": 270,
	"./plain/ski_tour_waterfall.svg": 271,
	"./plain/snowshoe_tour_alp.svg": 272,
	"./plain/snowshoe_tour_bridge.svg": 273,
	"./plain/snowshoe_tour_catering.svg": 274,
	"./plain/snowshoe_tour_cave.svg": 275,
	"./plain/snowshoe_tour_climbing_area.svg": 276,
	"./plain/snowshoe_tour_departure_arrival.svg": 277,
	"./plain/snowshoe_tour_lake.svg": 278,
	"./plain/snowshoe_tour_marking_point.svg": 279,
	"./plain/snowshoe_tour_summit.svg": 280,
	"./plain/snowshoe_tour_traverse.svg": 281,
	"./plain/snowshoe_tour_waterfall.svg": 282,
	"./plain/via_ferrata_alp.svg": 283,
	"./plain/via_ferrata_bridge.svg": 284,
	"./plain/via_ferrata_catering.svg": 285,
	"./plain/via_ferrata_cave.svg": 286,
	"./plain/via_ferrata_climbing_area.svg": 287,
	"./plain/via_ferrata_departure_arrival.svg": 288,
	"./plain/via_ferrata_lake.svg": 289,
	"./plain/via_ferrata_marking_point.svg": 290,
	"./plain/via_ferrata_summit.svg": 291,
	"./plain/via_ferrata_traverse.svg": 292,
	"./plain/via_ferrata_waterfall.svg": 293
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/img/icons/poi_routes \.svg$
// module id = 173
// module chunks = 0 2